export default "__VITE_ASSET__D6VI8TMw__"